module.exports = __webpack_public_path__ + "assets/images/resize.9320a3f2aff5423c49896c4270bcd055.svg";